<template>
    <div class="obflink" :id="idName" :class="className" :data-href="dataHref">
        <slot name="content"></slot>
    </div>
</template>

<script>
    import "@/components/ObfuscateLink/ObfuscateLink.scss";

    export default {
        name: "ObfuscateLink",

        props: {
            dataHref: {
                type: Object,
                required: true,
            },
            className: {
                type: String,
                required: false,
            }
        },

        mounted() {
            document.querySelectorAll('.obflink').forEach(function(element) {
                var obfLink = element.getAttribute('data-href');
                element.dataset.hrefObf = btoa(obfLink); 

                element.addEventListener('click', function(e) {
                    var link = atob(this.dataset.hrefObf);
                    window.open(link, "_self");
                });

                setTimeout(() => {
                    element.removeAttribute('data-href');
                }, "1500");
            });

        }
    }
</script>